"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KoraLabsProvider = exports.HandleClientProvider = void 0;
var HandleClientProvider_abstract_class_1 = require("./HandleClientProvider.abstract.class");
Object.defineProperty(exports, "HandleClientProvider", { enumerable: true, get: function () { return HandleClientProvider_abstract_class_1.HandleClientProvider; } });
var KoraLabsProvider_class_1 = require("./KoraLabsProvider.class");
Object.defineProperty(exports, "KoraLabsProvider", { enumerable: true, get: function () { return KoraLabsProvider_class_1.KoraLabsProvider; } });
/**
 * @todo
 * Ensure correct resolving of data between CIP-25 and CIP-68 handles.
 */
// export { BlockfrostProvider, BlockfrostHandle } from './BlockfrostProvider.class';
